<script setup lang="ts">
import { ref } from "vue";
// @ts-ignore
import DownloadBrochureForm from "@/components/download-brochure-form";

withDefaults(defineProps<{ tags: any; mailchimpIds: string[]; mailchimpGroupId: string; title: string; description: string; url: string; attrTitle: string }>(), {
    mailchimpIds: () => [],
});

const open = ref(false);
</script>

<template>
    <div class="flex flex-wrap gap-[24px]">
        <button id="download-brochure-button" @click="open = true" class="btn btn-brown-200 cta-project-download section-project_brochure flex flex-row items-center gap-8" :data-project-download="attrTitle">
            <span>Download nu</span>
        </button>
    </div>

    <div v-if="open" class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-[100] bg-popup cursor-pointer transition-all" @click="open = false">
        <div class="bg-brown-100 md:rounded-[4px] p-[32px] w-full z-[300] max-w-[560px] text-left relative border-2 border-beige-200" @click.stop>
            <fa-icon icon="close" class="text-15 text-beige-200 absolute right-[32px] top-[32px]" @click="open = false" />

            <download-brochure-form :title="title" :description="description" :url="url" :mailchimp-group-id="mailchimpGroupId" :mailchimp-ids="mailchimpIds" :tags="tags" />
        </div>
    </div>
</template>
